<app-titulo-paginas titulo="Lista de Relatórios"></app-titulo-paginas>
<div *ngIf="loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<mat-card class="example-card">
    <mat-card-content>
        <div class="table-responsive-vertical">
            <table class="table table-filter table-hover" [svData]="data$ | async" #sv="svDataTable" [svRowsOnPage]="10">
                <thead>
                    <tr>
                        <th>
                            <sv-default-sorter svSortBy="paciente" svSortOrder="asc" by="paciente">Paciente
                            </sv-default-sorter>
                        </th>
                        <th style="width: 5%;">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of sv.data; let i = index;">
                        <td data-title="Paciente">{{item.pessoa.nome}}</td>
                        <td data-title="Ações" class="acao-btn-tabela" style="vertical-align: middle;">
                            <a href="javascript:void(0)" [matMenuTriggerFor]="menu" matTooltip="Outras Ações">
                                <mat-icon aria-hidden="true" style="color: #4fd994;" aria-label="Example home icon">menu
                                </mat-icon>
                            </a>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="gerarPdf(item)">
                                    <mat-icon style="color: #d9534f;">picture_as_pdf
                                    </mat-icon>
                                    <span>Gerar PDF</span>
                                </button>
                            </mat-menu>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="4">
                            <sv-bootstrap-paginator [rowsOnPageSet]="[5,10,25]"></sv-bootstrap-paginator>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </mat-card-content>
</mat-card>